/**
 * Format a phone number for display: +1 (XXX) XXX-XXXX
 * Handles 10-digit US numbers with or without country code.
 * Returns the original string if it doesn't match a known pattern.
 */
export const formatPhoneNumber = (phone) => {
  if (!phone) return "";
  const cleaned = String(phone).replace(/[^\d+]/g, "");
  const digitsOnly = cleaned.replace(/\D/g, "");
  const withoutCountryCode =
    digitsOnly.startsWith("1") && digitsOnly.length === 11
      ? digitsOnly.slice(1)
      : digitsOnly;

  if (withoutCountryCode.length === 10) {
    return `+1 (${withoutCountryCode.slice(0, 3)}) ${withoutCountryCode.slice(3, 6)}-${withoutCountryCode.slice(6)}`;
  }
  return phone;
};
